import React from 'react';
import { bool, arrayOf } from 'prop-types';
import cx from 'classnames';

import coord from 'propTypes/coord';

import styles from './SegmentPath.scss';

export default function SegmentPath({ latLngList, isActive, isSelected, isDisconnected }) {
  // eslint-disable-next-line global-require
  const { Polyline } = require('react-leaflet');

  return (
    <div>
      <Polyline
        className={cx(styles.outline, {
          [styles.isActive]: isActive,
        })}
        positions={latLngList}
      />
      {isActive &&
        <Polyline
          positions={latLngList}
          className={cx(styles.underline, {
            [styles.statusSelected]: isSelected,
            [styles.isDisconnected]: isDisconnected,
          })}
        />}
      <Polyline
        positions={latLngList}
        className={cx(styles.line, {
          [styles.statusSelected]: isSelected,
          [styles.isDisconnected]: isDisconnected,
          [styles.isActive]: isActive,
        })}
      />
    </div>
  );
}

SegmentPath.propTypes = {
  latLngList: arrayOf(coord).isRequired,
  isActive: bool.isRequired,
  isSelected: bool,
  isDisconnected: bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Map/CreateRoute/SegmentPath/index.js